import { faNewspaper } from '@fortawesome/pro-light-svg-icons/faNewspaper';
import { faTwitter } from '@fortawesome/free-brands-svg-icons/faTwitter';
import { faFileChartPie } from '@fortawesome/pro-light-svg-icons/faFileChartPie';
import { faChartArea } from '@fortawesome/pro-light-svg-icons/faChartArea';
import { faVideo } from '@fortawesome/pro-light-svg-icons/faVideo';
import { faBallotCheck } from '@fortawesome/pro-light-svg-icons/faBallotCheck';
import { faTags } from '@fortawesome/pro-light-svg-icons/faTags';
import { faSmileBeam } from '@fortawesome/pro-light-svg-icons/faSmileBeam';
import { faStarHalfAlt } from '@fortawesome/pro-light-svg-icons/faStarHalfAlt';
import { faAnalytics } from '@fortawesome/pro-light-svg-icons/faAnalytics';
import { faFolderOpen } from '@fortawesome/pro-light-svg-icons/faFolderOpen';
import { faExclamationSquare } from '@fortawesome/pro-light-svg-icons/faExclamationSquare';

export const fundamentalData = [
  {
    id: 1,
    text: 'News & Research',
    icon: faNewspaper,
    description: 'Public content and premium non-public content without paywalls or ads',
    hoverClass: 'news-research',
  },
  {
    id: 2,
    text: 'Filings',
    icon: faFileChartPie,
    description: 'For public and private companies from regulators and stock exchanges',
    hoverClass: 'filings',
  },
  {
    id: 3,
    text: 'Prices and Charts',
    icon: faChartArea,
    description: 'For most securities from around the world in one place',
    hoverClass: 'price-chart',
  },
  {
    id: 4,
    text: 'Videos',
    icon: faVideo,
    description: 'Investing, trading, and business-related videos from major publications and influencers',
    hoverClass: 'coming-soon',
    comingSoon: true,
  },
  {
    id: 5,
    text: 'Fundamentals',
    icon: faBallotCheck,
    description: 'All the data and ratios you need to make your decisions',
    hoverClass: 'coming-soon',
    comingSoon: true,
  },
];

export const alternativeData = [
  {
    id: 1,
    text: 'NLU Tags',
    icon: faTags,
    description: 'Machine-readable tags that make categorising and analysing textual content simple',
    hoverClass: 'tags',
  },
  {
    id: 2,
    text: (
      <>
        News and
        <br />
        {' '}
        Social Sentiment
      </>
    ),
    icon: faSmileBeam,
    description: 'How the people and the markets feel about securities, stories, and any of our 300k+ covered topics',
    hoverClass: 'sentiment',
  },
  {
    id: 3,
    text: 'Major Financial Events Tracking',
    icon: faAnalytics,
    description: 'Coverage of events that move markets, from acquisitions to bankruptcies and more',
    hoverClass: 'finance-tracking',
  },
  {
    id: 4,
    text: (
      <>
        Ratings and
        <br />
        {' '}
        Reviews
      </>
    ),
    icon: faStarHalfAlt,
    starIcon: true,
    description: 'Leverage aggregated customer-based content for deeper insights',
    hoverClass: 'rating',
  },
  {
    id: 5,
    text: 'Content Summarisation',
    icon: faFolderOpen,
    comingSoon: true,
    description: 'One summary for a stock, a story, a sector, a location, or an entire watchlist of those topics',
    hoverClass: 'coming-soon',
  },
  {
    id: 6,
    text: (
      <>
        Spam
        <br />
        Probabilities
      </>
    ),
    icon: faExclamationSquare,
    comingSoon: true,
    description: 'A score to help you ignore the useless and focus on the useful, with convenient numerical filters',
    hoverClass: 'coming-soon',
  },
];
